module.exports = __webpack_public_path__ + "img/book-01_1.ff1a3313.png";